import { FaHardHat, FaUtensils, FaHeartbeat, FaCar, FaTshirt, FaLink, FaEllipsisH } from 'react-icons/fa';

export function getYouTubeId(url) {
  if (!url) return null;
  const match = url.match(
    /(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|v\/))([^&?/\s]+)/
  );
  return match ? match[1] : null;
}

export function formatBDT(amount) {
  return `৳ ${Number(amount).toLocaleString('en-BD')}`;
}

export function truncate(str = '', maxLen = 120) {
  return str.length <= maxLen ? str : str.slice(0, maxLen) + '…';
}

export const STATUS_LABEL = {
  upcoming:  'Upcoming',
  ongoing:   'Ongoing',
  completed: 'Completed',
};

// Keys match backend enum exactly
export const CAT_META = {
  construction:     { label: 'Building Construction',              icon: FaHardHat,   color: '#BC002D' },
  nursing:          { label: 'Nursing',                            icon: FaHeartbeat, color: '#E85D0A' },
  driving:          { label: 'Driving',                            icon: FaCar,       color: '#006A4E' },
  sewing_operator:  { label: 'Garment Sewing Operator(Female Only)', icon: FaTshirt,  color: '#5B8DEF' },
  linking_operator: { label: 'Linking Operator(Female Only)',      icon: FaLink,      color: '#8B6E3A' },
  other:            { label: 'EDC & Others',                       icon: FaEllipsisH, color: '#7C6B8A' },
};
